import Fire from '../config/Fire';
import {
	PLAYERS_FETCH,
	PLAYERS_FETCH_SUCCESS,
	PLAYERS_FETCH_FAIL,
	PLAYERS_TOGGLE_EDIT,
	PLAYERS_EDIT_AVATAR_TEXT_CHANGE,
	PLAYERS_EDIT_FNAME_TEXT_CHANGE,
	PLAYERS_EDIT_SURNAME_TEXT_CHANGE,
	PLAYERS_EDIT_INITAL_TEXT_CHANGE,
	PLAYERS_EDIT_POSITION_CHANGE,
	PLAYERS_EDIT_SQUAD_NUM_TEXT_CHANGE,
	PLAYERS_UPDATE,
	PLAYERS_UPDATE_SUCCESS,
	PLAYERS_UPDATE_FAIL,
	PLAYERS_NEW,
	PLAYERS_NEW_SUCCESS,
	PLAYERS_NEW_FAIL,
	PLAYERS_DELETE,
	PLAYERS_DELETE_SUCCESS,
	PLAYERS_DELETE_FAIL,
} from './types';

export const playerFetch = () => {
	return dispatch => {
		dispatch({ type: PLAYERS_FETCH });
		Fire.firestore()
			.collection('players')
			.get()
			.then(function(querySnapshot) {
				const obj = {};
				let arr = [];
				querySnapshot.forEach(function(doc) {
					arr = [...arr, parseInt(doc.data().squadNumber, 10)];
					let v = {};
					v = doc.data();
					v.readOnly = true;
					v.onChange = doc.data();
					obj[doc.data().squadNumber] = v;
					obj[doc.id] = doc.data();
				});
				return dispatch({
					type: PLAYERS_FETCH_SUCCESS,
					payload: obj,
					listByID: arr.sort((a, b) => a - b),
				});
			})
			.catch(function(_err) {
				console.log('_err', _err);
				return dispatch({ type: PLAYERS_FETCH_FAIL });
			});
	};
};

export const playerUpdate = obj => {
	return dispatch => {
		dispatch({ type: PLAYERS_UPDATE, payload: obj });
		Fire.firestore()
			.collection('players')
			.doc(obj.surname.replace(/\s+/g, '').toLowerCase())
			.set(
				{
					firstName: obj.firstName,
					surname: obj.surname,
					initial: obj.initial,
					squadNumber: obj.squadNumber,
					playerAvatar: obj.playerAvatar,
					position: obj.position,
					positionIndex: obj.positionIndex,
				},
				{ merge: true },
			)
			.then(function() {
				return dispatch({ type: PLAYERS_UPDATE_SUCCESS, payload: obj, id: obj.squadNumber });
			})
			.catch(function(_e) {
				console.log('_error', _e);
				dispatch({
					type: PLAYERS_UPDATE_FAIL,
					id: obj.squadNumber,
					error: true,
					errorText: _e.message,
				});
				setTimeout(function() {
					return dispatch({
						type: PLAYERS_UPDATE_FAIL,
						id: obj.squadNumber,
						error: false,
						errorText: '',
					});
				}, 1500);
			});
	};
};

export const playerNew = obj => {
	return dispatch => {
		dispatch({ type: PLAYERS_NEW });
		Fire.firestore()
			.collection('players')
			.doc(obj.surname.replace(/\s+/g, '').toLowerCase())
			.set(
				{
					firstName: obj.firstName,
					surname: obj.surname,
					initial: obj.initial,
					squadNumber: obj.squadNumber,
					playerAvatar: obj.playerAvatar,
				},
				{ merge: true },
			)
			.then(function() {
				return dispatch({ type: PLAYERS_NEW_SUCCESS, payload: obj, id: obj.squadNumber });
			})
			.catch(function(_e) {
				console.log('_error', _e);
				dispatch({ type: PLAYERS_NEW_FAIL, error: true, errorText: _e.message });
				setTimeout(function() {
					return dispatch({ type: PLAYERS_NEW_FAIL, error: false, errorText: '' });
				}, 1500);
			});
	};
};

export const playerDelete = i => {
	return dispatch => {
		dispatch({ type: PLAYERS_DELETE });
		Fire.firestore()
			.collection('players')
			.doc(i.surname.replace(/\s+/g, '').toLowerCase())
			.delete()
			.then(function() {
				return dispatch({
					type: PLAYERS_DELETE_SUCCESS,
					id: parseInt(i.squadNumber, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				dispatch({ type: PLAYERS_DELETE_FAIL, id: i, error: true, errorText: 'Failed to delete' });
				setTimeout(function() {
					return dispatch({ type: PLAYERS_DELETE_FAIL, id: i, error: false, errorText: '' });
				}, 1500);
			});
	};
};

export const toggleEdit = i => ({ type: PLAYERS_TOGGLE_EDIT, id: i });
export const onAvatarTextChange = (i, text) => ({
	type: PLAYERS_EDIT_AVATAR_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onFnameTextChange = (i, text) => ({
	type: PLAYERS_EDIT_FNAME_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onSurnameTextChange = (i, text) => ({
	type: PLAYERS_EDIT_SURNAME_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onInitialTextChange = (i, text) => ({
	type: PLAYERS_EDIT_INITAL_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onPositionChange = (i, text) => ({
	type: PLAYERS_EDIT_POSITION_CHANGE,
	id: i,
	payload: text,
});
export const onSquadNumTextChange = (i, text) => ({
	type: PLAYERS_EDIT_SQUAD_NUM_TEXT_CHANGE,
	id: i,
	payload: text,
});

export default { playerFetch, toggleEdit, playerUpdate, playerNew, playerDelete };



// WEBPACK FOOTER //
// ./src/actions/PlayerActions.js